import {Box, Stack, SvgIconOwnProps} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {useThemeContext} from "@theme";
import React, {useEffect} from "react";

export type ConfirmDialogLabel = {
  title?: string;
  text?: string | React.ReactNode;
  confirm?: string;
  cancel?: string;
};

type Props = {
  label?: ConfirmDialogLabel;
  open: boolean;
  loading?: boolean;
  Icon?: React.ComponentType<SvgIconOwnProps>;
  onConfirm: () => void;
  onCancel?: () => void;
};
export default function ConfirmDialog(props: Props) {
  const {open, label, onConfirm, onCancel, Icon, loading} = props;
  const {theme} = useThemeContext();
  const [show, setShow] = React.useState(false);

  useEffect(() => setShow(open), [open, setShow]);

  const handleClose = () => {
    setShow(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleConfirm = () => {
    if (loading === undefined) {
      // uno stato loading settato indica una chiamata asincrona, in questo caso la dialog va chiusa dal parent
      setShow(false);
    }
    onConfirm();
  };

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title">
      {Icon && (
        <Stack direction="row" mt={2} justifyContent="center">
          <Box
            sx={{
              bgcolor: theme.palette.secondary.dark,
              width: "64px",
              borderRadius: "32px",
              height: "64px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Icon
              fontSize="large"
              sx={{
                color: theme.palette.getContrastText(
                  theme.palette.secondary.dark,
                ),
              }}
            />
          </Box>
        </Stack>
      )}
      <DialogTitle id="responsive-dialog-title" textAlign={"center"}>
        {label?.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{label?.text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} color="primary">
          {label?.cancel ?? "Cancel"}
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          autoFocus
          disabled={loading}
          loading={loading}>
          {label?.confirm ?? "Ok"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
